import { TableName } from "src/lib/dexie-db/constants";
import { RemoteCollectionName } from "src/lib/sync-box/constants";
import SyncBoxFactory from "src/lib/sync-box/SyncBoxFactory";
import { COMMUNITY_SYNC_INTERVAL, EXAM_LEVEL_SYNC_INTERVAL, SUB_TREE_SYNC_INTERVAL } from "./constants";
export const getExamLevelSubTreeSyncBox = (examLevelId) => {
    return SyncBoxFactory.getInstance({
        collectionName: TableName.QNA_NODE,
        remoteCollectionName: RemoteCollectionName.QNA_NODE,
        pushConfig: {
            enabled: false,
        },
        pullConfig: {
            filters: {
                ancestors: examLevelId,
            }
        },
        syncInterval: SUB_TREE_SYNC_INTERVAL,
        staleThresholdDays: 30,
    });
};
export const getExamLevelSyncBox = (examLevelId) => {
    return SyncBoxFactory.getInstance({
        collectionName: TableName.QNA_NODE,
        remoteCollectionName: RemoteCollectionName.QNA_NODE,
        pushConfig: {
            enabled: false,
        },
        pullConfig: {
            filters: {
                _id: examLevelId
            }
        },
        syncInterval: EXAM_LEVEL_SYNC_INTERVAL,
        staleThresholdDays: -1,
    });
};
export const getCommunitySyncBox = (communityId) => {
    return SyncBoxFactory.getInstance({
        collectionName: TableName.QNA_NODE,
        remoteCollectionName: RemoteCollectionName.QNA_NODE,
        pushConfig: {
            enabled: false,
        },
        pullConfig: {
            filters: {
                _id: communityId,
            }
        },
        syncInterval: COMMUNITY_SYNC_INTERVAL,
        staleThresholdDays: -1,
    });
};
export default function getExamLevelSyncBoxes(communityId, examLevelId) {
    return {
        subTree: getExamLevelSubTreeSyncBox(examLevelId),
        examLevel: getExamLevelSyncBox(examLevelId),
        community: getCommunitySyncBox(communityId),
    };
}
